<template>
  <div class="xianxia-xingwei-detail child-detail">
    <ChildModal :title="$store.state.childModalTitle" >


      <div class="tingliushijian single-line">
<!--        <div class="chart-title"></div>-->
        <div class="chart-content">
          <!--<div class="chart-title">情绪占比图</div>-->
          <div class="chart-content">
           <div class="comments">
           <ul class="comment-filter">
             <li><div>全部评论(12380)</div></li>
             <li class="active"><div class="good"></div><div>好评(12380)</div></li>
             <li><div class="bad"></div><div>差评(12380)</div></li>
             <li class="right active">
                 <div @click="dateListShow = !dateListShow" class="expand">
              <div class="drop-name">{{dateSelected}}</div>
              <div class="arrow"></div>

              <ul class="drop-list" v-show="dateListShow">
                <li :key="index"
                    @click="dateSelected = item"
                    v-for="(item, index) in dateList">
                  {{ item }}
                </li>
              </ul>
            </div>
             </li>
           </ul>
          
           <ul class="comment-tab">
               <li v-for="(item,index) in liList" v-on:click="addClass(index)" v-bind:class="{ 
         active:index==current}">{{item.title}}</li>
           </ul>
            <ul class="commentList">
                <li><img src="../../assets/jingqukoubei/fave_nan.png" />
                    <div class="comment">网红景点“天空之镜”青海茶卡盐湖的美丽风景令人沉醉，纯美干净的环境赏心悦目。</div>
                    <div class="dec">
                        <div>2018-06-06 17:56:43</div>
                        <div>评论景区：宽街窄巷（2A I 风景）</div>
                        <div>数据源4 维度：全部</div>
                    </div>
                </li>
                <li><img src="../../assets/jingqukoubei/fave_nan.png" />
                    <div class="comment">不仅破坏了“天空之镜”美感，亦存在污染环境、危及生态的隐…</div>
                    <div class="dec">
                        <div>2018-06-06 17:56:43</div>
                        <div>评论景区：宽街窄巷（2A I 风景）</div>
                        <div>数据源4 维度：全部</div>
                    </div>
                </li>
                <li><img src="../../assets/jingqukoubei/fave_nan.png" />
                    <div class="comment">网红景点“天空之镜”青海茶卡盐湖的美丽风景令人沉醉</div>
                    <div class="dec">
                        <div>2018-06-06 17:56:43</div>
                        <div>评论景区：宽街窄巷（2A I 风景）</div>
                        <div>数据源4 维度：全部</div>
                    </div>
                </li>
                <li><img src="../../assets/jingqukoubei/fave_nan.png" />
                    <div class="comment">网红景点“天空之镜”青海茶卡盐湖的美丽风景令人沉醉，纯美干净的环境赏心悦目危及生态的隐…</div>
                    <div class="dec">
                        <div>2018-06-06 17:56:43</div>
                        <div>评论景区：宽街窄巷（2A I 风景）</div>
                        <div>数据源4 维度：全部</div>
                    </div>
                </li>
                <li><img src="../../assets/jingqukoubei/fave_nan.png" />
                    <div class="comment">网红景点“天空之镜”青海茶卡盐湖的美丽风景令人沉醉，纯美干净的环境赏心悦目，可游客随手扔掉的垃圾则大煞风景，不仅破坏了“天空之镜”美感，亦存在污染环境、危及生态的隐…</div>
                    <div class="dec">
                        <div>2018-06-06 17:56:43</div>
                        <div>评论景区：宽街窄巷（2A I 风景）</div>
                        <div>数据源4 维度：全部</div>
                    </div>
                </li>
                
            </ul>
<!--               <a clas href="">查看所有评论></a>-->
           </div>
          </div>
        </div>
      </div>
      <div class="zhanwei"></div>
    </ChildModal>
  </div>
</template>

<script>
import ChildModal from "@/components/Common/ChildModal.vue";



export default {
  name: "scenicjingqukoubei",
  components: {
    ChildModal,

  },
  props: {},
  data() {
    return {
        current:0,
            liList:[
               {title:'综合'},
               {title:'服务(9.5)'},
               {title:'价格(9.5)'},
               {title:'设施(9.5)'},
               {title:'交通(9.5)'},
               {title:'餐饮(9.5)'},
               {title:'环境(9.5)'},
               {title:'厕所(9.5)'},
               {title:'安全(9.5)'},
               {title:'项目(9.5)'},
               {title:'信息化(9.5)'}
            ],
        
      dateSelected: "一周内",
      dateListShow: false,
      dateList: ["一周内","一月内","三月内","最近一年"],
     };
  },
  mounted() {
  

  },
  methods: {
      addClass(index){
          this.current=index
    }
  }
};
</script>

<style scoped lang="less">
.geyebili {
  padding: 0 1rem;
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom: 0.05rem !important;
  .chart-content {
    ol {
      width: 44%;
    }
    ul {
      margin: 1rem auto 0;
      position: relative;
      .yibiao1 {
        float: left;
      }
      .yibiao3 {
        float: right;
      }
      .yibiao2 {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translate(-50%, -20%) scale(1.5);
      }
      li {
        width: 2.28rem;
        height: 2.28rem;
        position: relative;
        .info {
          margin-top: 0.12rem;
          width: 100%;
          text-align: center;
          .bili {
            color: #ff553e;
          }
        }
        .bg {
          width: 2.28rem;
          height: 1.14rem;
          background: url(../../assets/youkexianxiaxingweifenxi/yibiaopan.png)
            no-repeat;
          background-size: 100% 100%;
        }
        .pointer {
          transition: all 0.4s;
          width: 2.28rem;
          height: 2.28rem;
          background: url(../../assets/youkexianxiaxingweifenxi/yibiaopan_pointer.png)
            no-repeat;
          background-size: 100% 100%;
          position: absolute;
          top: 0;
          left: 0;
          transform: rotate(0deg);
        }
      }
    }
  }
}

.child-detail {
  .tingliushijian {
    .chart-content {
      ol {
        width: 28%;
        li {
          width: 33.33%;
        }
      }
    }
  }
  .zhusuretu {
    .chart-content {
      height: 270px;
      width: 80%;
      ol {
        width: 100%;
        li {
          width: 8.33%;
        }
      }
    }
    .expand {
      height: 0.3rem;
      position: absolute;
      left: 1.1rem;
      top: 0.1rem;
      > div {
        float: left;
        height: 0.3rem;
        line-height: 0.3rem;
      }
      .local {
        width: 0.3rem;
        background: url(../../assets/youkexianxiaxingweifenxi/local.png);
        background-size: 100% 100%;
      }
      .arrow {
        width: 0.3rem;
        background: url(../../assets/header_menu/arrow.png);
        background-size: 100% 100%;
      }
      .city-list {
        position: absolute;
        left: 0;
        top: 0.3rem;
        width: 100%;
        background: #052148;
        border: 1px solid #00cdff;
        padding: 0.05rem 0;
        box-sizing: border-box;
        li:hover {
          background: #0c3964;
        }
      }
    }
  }
}

.content {
  overflow: hidden;
  width: 100%;
  height: 92.5%;
  box-sizing: border-box;
  .tab {
    width: 9.4rem;
    height: 0.24rem;
    margin: 0 auto 0.26rem;
    li {
      width: 12.5%;
      height: 100%;
      float: left;
      color: #fff;
      /*background: url(../../assets/spot_tab_bg.png);*/
      background-size: 100% 100%;
      cursor: pointer;
    }
    .current {
      /*background: url(../../assets/spot_tab_bg_.png);*/
      background-size: 100% 100%;
    }
  }
}
.header {
  /*.chart-content {*/
  /*height: 270px;*/
  /*width: 80%;*/
  ol {
    width: 100%;
    li {
      width: 8.33%;
    }
  }
  /*}*/
  .expand {
    height: 0.3rem;
    position: absolute;
    left: 1.1rem;
    top: 0.1rem;
    cursor: pointer;
    > div {
      float: left;
      height: 0.3rem;
      line-height: 0.3rem;
    }
    .local {
      width: 0.3rem;
      background: url(../../assets/youkexianxiaxingweifenxi/local.png);
      background-size: 100% 100%;
    }
    .arrow {
      width: 0.3rem;
      background: url(../../assets/header_menu/arrow.png);
      background-size: 100% 100%;
    }
    .city-list {
      position: absolute;
      left: 0;
      top: 0.3rem;
      width: 100%;
      background: #052148;
      border: 1px solid #00cdff;
      padding: 0.05rem 0;
      box-sizing: border-box;
      li:hover {
        background: #0c3964;
      }
    }
  }
}

.line {
  width: 100%;
  height: 3rem;
  margin-bottom: 0.75rem;
  > div {
    width: 50%;
    padding: 0 0.7rem;
    box-sizing: border-box;
    height: 100%;
    float: left;
  }
}
.comments{
    background: #082f4a;
    width:95%;
    margin: 0 auto;
    border: 1px solid #0b6e9c;
    .comment-filter{
        text-align: left;
        padding: 0.1rem 0.2rem 0;
        li{
            display: inline-block;
            position: relative;
            text-align: center;
            border-radius: 0.3rem;
            padding: 0.02rem 0.2rem;
            border: 1px solid #fff;
            color: #fff;
            margin-right: 0.2rem;
            cursor: pointer;
            div{display: inline-block;}
            &.right{
              position: absolute;
            right: 0.2rem;
            }
            &.active{
                border-color:#ffcf4d;
                color: #ffcf4d;
              .arrow {
                background: url(../../assets/jingqukoubei/arrow_on.png);
              background-repeat: no-repeat;
                }
                  
          .good {
            background: url(../../assets/jingqukoubei/good_on.png);
          }
            
          .bad {
            background: url(../../assets/jingqukoubei/bad_on.png);
          }
        }
            .good ,.bad{
                width: 15px;
            height: 0.15rem;
            margin-right: 0.05rem;
                display: inline-block;
                vertical-align: middle;
            }
          .good {
            background: url(../../assets/jingqukoubei/good_off.png);
            background-size: 100% 100%;
          }
            
          .bad {
            background: url(../../assets/jingqukoubei/bad_off.png);
            background-size: 100% 100%;
          }
            
        }
        .expand {
          width: 1rem;
/*          height: 0.3rem;*/
          cursor: pointer;
          > div {
/*            width: 1.3rem;*/
/*            height: 0.3rem;*/
/*            line-height: 0.3rem;*/
            display: inline-block;
              vertical-align: middle;
          }
          .arrow {
            width: 11px;
            height: 0.1rem;
              margin-left: 0.1rem;
            background: url(../../assets/jingqukoubei/arrow_off.png);
            background-size: 100% 100%;
          }
          .drop-list {
            z-index: 9999;
            position: absolute;
            left: 0;
            top: 0.3rem;
            width: 100%;
              margin: 0;
              text-align: center;
            background: #052148;
            border: 1px solid #00cdff;
            padding: 0.05rem 0;
            box-sizing: border-box;
              li{
                  padding: 0;
                  border: 0;
              border-radius: 0;
                  margin: 0;
                  width: 100%;
                  display: block;
              }
            li:hover {
              background: #0c3964;
            }
          }
        }
    }
    .comment-tab{
        text-align: left;
        padding: 0.2rem 0.2rem 0;
        li{
            color: #fff;
            background: #006cb5;
            display: inline-block;
            text-align: center;
            font-size: 0.14rem;
            width: 1.2rem;
            margin:0 0.2rem 0.15rem 0;
            padding: 0.02rem 0;
            cursor: pointer;
            &.active{
            background: #00cdff;
            }
        }
    }
    .commentList{
        text-align: left;
            li{
                position: relative;
                padding: 0.1rem 0.3rem;
                &:nth-child(even){
                    background: #06527c;
                }
            }
        img{width: 0.5rem;height: 0.5rem;position: absolute;left: 0.3rem;}
        .comment,.dec{margin-left: 0.7rem;}
        .comment{
            width: 90%;
            display: block;
            font-size: 0.16rem;
            color: #fff;
            margin-bottom: 0.1rem;
        }
        .dec{
            color: #aaaaaa;
            font-size: 0.14rem;
            div{
                display: inline-block;
                margin-left: 0.3rem;
                &:first-child{
                    margin-left: 0;
                }
            }
        }
    }
}
</style>
